import useMultiSelectComboBox from '../AbstractComboBox/hooks/useMultiSelectComboBox';
import getUserTopResults from './getUserTopResults';
import { ComboBoxInputProps } from '../AbstractComboBox/hooks/useComboBoxInput';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';

export default function useUserMultiSelectComboBox(inputProps: ComboBoxInputProps, initialValue?: TopUserResult[]) {
  return useMultiSelectComboBox(getUserTopResults, inputProps, initialValue);
}
